module.exports = __webpack_public_path__ + "bin/dda683e4d558e99db90a3245c9ad80f8.svg";